const data = [
  {
    id: "1",
    title: "Tracking and Staking Poker App with Vue.js",
    skills: [
      "Develop a mobile app with Vue.js",
      "State management with Pinia",
      "Dashboard using ChartJs",
      "User-friendly interface design",
      "Create logo and mockup with Figma",
    ],
    technologies: [
      "Vue.js",
      "Quasar",
      "TypeScript",
      "Pinia",
      "Supabase",
      "Figma",
    ],
    url: "https://github.com/AmandaSrisourath/PokerSeries",
    img: "pokerSeries.webp",
  },
  {
    id: "2",
    title: "Heatmap Visualization with Vue.js and Esri",
    skills: [
      "Interactive heatmaps with Vue.js",
      "State management with Pinia",
      "Use Esri to visualize geospatial data",
      "Implementing custom map layers",
      "API development with Node.js",
    ],
    technologies: [
      "Vue.js",
      "Quasar",
      "Pinia",
      "JavaScript",
      "Node.js",
      "Esri",
    ],
    url: "https://coverage.powertec.com.au/login",
    img: "ncm.webp",
  },
  {
    id: "3",
    title: "Todo List Web App with Next.js",
    skills: [
      "Develop a web app with Next.js",
      "Implement responsive UI",
      "Optimize feature performance",
      "Design intuitive UI",
      "API development with Node.js",
    ],
    technologies: [
      "Next.js",
      "NextUI",
      "React.js",
      "TypeScript",
      "Node.js",
      "TailwindCss",
    ],
    url: "https://github.com/AmandaSrisourath/DoDabble",
    img: "doDabble.webp",
  },
  {
    id: "4",
    title: "Create a React dropdown library",
    skills: [
      "Built and published a reusable dropdown component library using React",
      "Unit testing",
    ],
    technologies: [
      "Jest",
      "React.js",
      "React Router",
      "Redux / Toolkit",
      "Testing-Library",
    ],
    url: "https://www.npmjs.com/package/basic-react-dropdown",
    img: "hrnet.webp",
  },
  {
    id: "5",
    title: "Use API for bank user account with React.js",
    skills: [
      "Implement a state manager in a React application using Redux / Toolkit",
      "Interact with an API",
      "Authentication with an API",
    ],
    technologies: ["React.js", "React Router", "Redux / Toolkit", "Axios"],
    url: "https://github.com/AmandaSrisourath/ArgentBank",
    img: "argentBank.webp",
  },
  {
    id: "6",
    title: "Build an analytics dashboard in React.js",
    skills: [
      "Interact with a web service",
      "Develop advanced graphical elements using recharts",
      "Produce technical documentation for an application",
    ],
    technologies: ["React.js", "React Router", "Axios", "Recharts"],
    url: "https://github.com/AmandaSrisourath/SportSee",
    img: "sportSee.webp",
  },
  {
    id: "7",
    title: "Build a React app with React Router",
    skills: [
      "Develop routes for a web app with React Router",
      "Manage state with React hooks",
      "Create reusable components",
      "Build responsive layouts with styled-components",
    ],
    technologies: ["React.js", "React Router", "Figma"],
    url: "https://amandasrisourath.github.io/Kasa/#/",
    img: "kasa.webp",
  },
  {
    id: "8",
    title: "Define the needs for a tutoring app",
    skills: [
      "Create mockups with Figma",
      "Contribute to a project using an agile methodology",
      "Identify the needs of the application from a specification",
      "Model a technical solution for a client",
    ],
    technologies: ["Figma", "Trello"],
    url: "https://www.figma.com/file/a9JwLOrCBB4HPMg0dZYJn1/Learn%40Home",
    img: "learn@home.webp",
  },
  {
    id: "9",
    title: "Create an accessible website",
    skills: [
      "Manage site events with JavaScript",
      "Develop a modular web application with design patterns",
      "Write maintainable JavaScript code",
      "Ensuring the accessibility of a website",
    ],
    technologies: ["HTML5", "CSS3", "SASS", "JS"],
    url: "https://amandasrisourath.github.io/FishEye/",
    img: "fishEye.webp",
  },
  {
    id: "10",
    title: "Make a dynamic page with CSS animations",
    skills: [
      "Ensuring the graphic consistency of a website",
      "Use a version control system for project tracking and hosting",
      "Implementing advanced graphic CSS effects",
      "Setting up Front-End environment",
    ],
    technologies: ["HTML5", "CSS3", "Figma"],
    url: "https://amandasrisourath.github.io/OhMyFood/",
    img: "ohMyFood.webp",
  },
  {
    id: "11",
    title: "Create a website with HTML5 and CSS3",
    skills: [
      "Implement a responsive interface",
      "Integrate content according to mockups",
      "Create custom layouts with Flexbox and Grid",
      "Design and implement animations with CSS3",
    ],
    technologies: ["HTML5", "CSS3", "Figma"],
    url: "https://amandasrisourath.github.io/Reservia/",
    img: "reservia.webp",
  },
];

export { data };
